import React from 'react';
import { TextControls, PaginationButton } from './components';
import Icon from '../icon/Icon';

export interface LeftSideControlsProps {
  selectedPage: number;
  onPageChange: (pageIndex: number) => void;
}

export const LeftSideControls: React.FC<LeftSideControlsProps> = ({ selectedPage, onPageChange }) => {
  const handlePreviousClick = () => onPageChange(selectedPage - 1);
  const handleFirstClick = () => onPageChange(1);

  return (
    <TextControls>
      <PaginationButton disabled={selectedPage <= 1} onClick={handleFirstClick}>
        <Icon type="angle-double-left" />
      </PaginationButton>

      <PaginationButton disabled={selectedPage <= 1} onClick={handlePreviousClick}>
        <Icon type="angle-left" />
      </PaginationButton>
    </TextControls>
  );
};
